/*
* Copyright (c) 2017 SGS Europe. All rights reserved.
*
* This program is the CONFIDENTIAL and PROPRIETARY property of 2017 SGS Europe.
* Any unauthorised use, reproduction, or transfer of this program is strictly
* prohibited.
*
* File Name:	Common.js
*
* Description:	Common JavaScript functions between all objects.
*
* History:		01-AUG-17	J Fuller	Initial implementation.
*				22-NOV-17	M Sherer	Changes for the Greenlight Annotation Module (DR207).
*				14-DEC-17	N Settle	Added a rounding function for the Greenlight Tech Tools Module (DR208).
*				19-JAN-18	N Settle	Added TextMeasurement Annotation Type to the eAnnotationTypes enumerator (DR208).
*				14-FEB-18	J Fuller	Added warning bubble and function to add placeholder text to input box.
*				21-FEB-18	P Raper		Added lockScreen() and formatDate() as part of UAT enhancements.
*				06-MAR-18	N Settle	Modified the slideDiv() function to take a boolean parameter to control whether the canvas is redrawn after the animate (DR208).
*				28-MAR-18	N Settle	Made the Pan function re-render the Barcode Measurement details so that it can move it into a better position to view (DR208).
*				12-OCT-18	S Dervey	Added eKeyboardShorcutBehaviours (GL205006).
*				16-OCT-18	J Swan		Added eAppovalStatus enum (GL205006)
*				07-NOV-18   S Norman    Added functions to display a pop-up window within greenlight. (DR212)
*   			19-NOV-18   R Pavolas   Moved bubble logic to new file,	changed the default changeCanvasFunction(), added ColourDensityPostit annotation type (DR158989).
*				05-DEC-18	N Alexander	Modified formatDate to apply a full date time format or time format if either is missing.
*				07-DEC-18	P Dickson	Added high pixel density support. (Feature 5334)
*				30-MAY-19	P Dickson	Implemented the SVG text functionality.
*				20-JAN-20	S Norman	Added drag, drop attachments functions, resize attachment pop-up functions
*										and general clean-up as part of UserStory 43113 - Upload Documents to Annotations)
*			    22-JAN-20   P Raper     Added generic method for processing API responses.
*			    05-FEB-20	R Pavolas	Added a bunch of helper methods and refactored changeCanvasFunction
*			    22-APR-20	J Morris	Added a prependDomElement function for adding new elements at the beginning of containers.
*/

/*
 *  - - - G L O B A L   V A R I A B L E S - - -
 */

var eAnnotationHandleTypes = {
	DragRect: 0,
	DeleteButton: 1,
	LeftResize: 2,
	RightResize: 3,
	TopResize: 4,
	BottomResize: 5,
	CreateNewAnnotation: 6
};

/**
 * Sort documents alphabetically.
 * @param {any} a - first parameter a
 * @param {any} b - Second parameter B
 * @returns {object} - sorted document
 */
function sortAlphabetical(a, b) {
	return a.DocumentName.toLowerCase() > b.DocumentName.toLowerCase() ? 1 : -1;
}

// Sorts annotation coordinates min/max of x or y.
var sortAnnotationCoords = {
	returnXMin: function (a, b) {
		return a[0] - b[0];
	},
	returnXMax: function (a, b) {
		return b[0] - a[0];
	},
	returnYMin: function (a, b) {
		return a[1] - b[1];
	},
	returnYMax: function (a, b) {
		return b[1] - a[1];
	}
};

var eApproverType = {
	Individual: 1,
	Group: 2,
	Hidden: 3
}

var eApproverStatus = {
	Pending: 0,
	Approved: 1,
	ApprovedChanges: 2,
	Rejected: 3
};

var eApprovalStatus = {
	Pending: 0,
	Approved: 1,
	ApprovedChanges: 2,
	Rejected: 3,
	AwaitingMyReview: 4
};

var eCompareMode = {
	NoCompare: 0,
	Blink: 1,
	Overlay: 2,
	SliderHorizontal: 3,
	SliderVertical: 4,
	SideBySide: 5,
	SideBySideDiff: 6,
	DifferencesOnly: 7
};

var eDocumentTypes = {
	PDF: 1,
	Image: 2,
	ThreeD: 3,
	Office: 4,
	SVG: 5,
	AnnotationAttachment: 6,
	AI: 7,
	CopyMagic: 8
};

var eRetrievalSource = {
	ApprovalId: 1,
	DocumentPageId: 2,
	DocumentId: 3
};

var eCanvasType = {
	Artwork: 1,
	Annotation: 2
};

var eMessageType = {
	Success: 1,
	Error: 2
};

var eAnnotationDivType = {
	Popup: 1,
	ListItem: 2
};

var eAnnotationTypes = {
	Postit: 0,
	Freedraw: 1,
	Rectangle: 2,
	Ellipse: 3,
	Line: 4,
	Global: 5,
	ThreeD: 6,
	TextMeasurement: 7,
	PointToPointMeasurement: 8,
	AreaMeasurement: 9,
	HorizontalCalliperMeasurement: 10,
	VerticalCalliperMeasurement: 11,
	ColourDensityMeasurement: 12,
	BarcodeMeasurement: 13,
	ColourDensityMeasurementPostit: 14,
	SVGRectangle: 15,
	SVGEllipse: 16,
	SVGPolygon: 17,
	TextHighlight: 18,
	TextClassification: 19
};

var eAnnotationColours = {
	blue: "#0000FF",
	red: "#FF0000",
	green: "#008000",
	orange: "#FFA500",
	purple: "#800080",
	cyan: "#00FFFF",
	magenta: "#FF00FF",
	yellow: "#FFFF00",
	grey: "#999999"
};

var eAnnotationStatuses = {
	Initial: 0,
	Approved: 1,
	Rejected: 2,
	Query: 3,
	ToDo: 4
};

var eAnnotationStatusUpdateType = {
	addStatus: 1,
	deleteStatus: 2,
	updateStatus: 3
};

var eFieldTypes = {
	AnnotationMainHeader: 0,
	ReplyHeader: 1,
	StatusHeader: 2,
	DifferenceHeader: 3,
	CopyMagic: 4
};

var eKeyboardShorcutBehaviours = {
	ZoomIn: 1,
	ZoomOut: 2,
	ZoomReset: 3,
	Pan: 4,
	PanTextCompare: 5
};

var eWheelZoomType = {
	Static: 1,
	Centered: 2,
	Smart: 3
};

var eZoomSpeed = {
	Slow: 1,
	Medium: 2,
	Fast: 3
};

var eZoomIncrements = {
	Smallest: 1,
	Small: 2,
	Medium: 3,
	Large: 4,
	Largest: 5
};

var eAlignmentType = {
	OnRequest: 1,
	Always: 2
};

var eHighlightType = {
	LeftToRight: 1,
	RightToLeft: 2
};

var eSVGNodeType = {
	None: 0,
	PointText: 1,
	AreaText: 2,
	PathText: 3
};

var eSVGBoundingElementType = {
	None: 0,
	Rectangle: 1,
	Ellipse: 2,
	Polygon: 3
};

var eReviewType = {
	ReadOnly: 1,
	Approver: 2,
	Sheriff: 3
};

// JQuery PEP setup to allow touch events
var events = [
  // base events
  'click',
  'pointerdown',
  'pointerup',
  'pointermove',
  'pointerover',
  'pointerout',
  'pointerenter',
  'pointerleave'
];

// Active Bubbles.
var g_oActiveBubbles = [];

// Keeps track of the next id to be used for the active bubble.
var g_iActiveBubbleId = 1;

// The number of seconds before a static bubble will auto-hide.
var g_iBubbleCloseSeconds = 5;

/**
 * Creates a new active bubble object.
 * @param {int} id - The id of the bubble.
 * @param {string} type - The type of bubble.
 * @param {bool} displayTop - If the bubble should be displayed at the top of the screen.
 * @param {bool} autoClose - If the bubble should auto close.
 */
function ActiveBubble(id, type, displayTop, autoClose) {
	this.id = id;
	this.type = type;
	this.displayTop = displayTop;
	this.autoClose = autoClose;
	this.displayDate = new Date();
}

/*
 *  - - - P U B L I C   M E T H O D S - - -
 */

/**
 * Adds a DOM Element to the Canvas
 * @param {int} id - ID of the notification
 * @param {string} type - Type of Action the DOM element will perform
 * @param {string} src - The location of the image
 * @param {string} className - The class identifier
 * @param {string} title - The tooltip.
 * @param {event} clickFunction - The click function to bind to the new element
 * @param {string} destination - The Div to append the element to.
 * @param {string} dataAttribute - The data attribute at be attached to element.
 * @param {string} dataAttributeValue - The data attribute value.
 * @returns {object} - The new element.
 */
function addDomElement(id, type, src, className, title, clickFunction, destination, dataAttribute, dataAttributeValue) {
	var element = createDomElement(id, type, src, className, title, clickFunction, dataAttribute, dataAttributeValue);
	destination.appendChild(element);

	return element;
}

/**
 * Adds a DOM Element to the Canvas as the first child within the container.
 * @param {int} id - ID of the notification
 * @param {string} type - Type of Action the DOM element will perform
 * @param {string} src - The location of the image
 * @param {string} className - The class identifier
 * @param {string} title - The tooltip.
 * @param {event} clickFunction - The click function to bind to the new element
 * @param {string} destination - The Div to append the element to.
 * @param {string} dataAttribute - The data attribute at be attached to element.
 * @param {string} dataAttributeValue - The data attribute value.
 * @returns {object} - The new element.,
 */
function prependDomElement(id, type, src, className, title, clickFunction, destination, dataAttribute, dataAttributeValue) {
	var element = createDomElement(id, type, src, className, title, clickFunction, dataAttribute, dataAttributeValue);
	destination.prepend(element);

	return element;
}


/**
 * Adds a DOM Element to the Canvas
 * @param {number} id - ID of the notification
 * @param {string} type - Type of Action the DOM element will perform
 * @param {string} src - The location of the image
 * @param {string} className - The class identifier
 * @param {string} title - The tooltip.
 * @param {event} clickFunction - The click function to bind to the new element
 * @param {string} destination - The Div to append the element to.
 * @returns {object} - The new element.
 */
function createDomElement(id, type, src, className, title, clickFunction, dataAttribute, dataAttributeValue) {
	var element = document.createElement(type);

	// Set the ID if we have it.
	if (id) {
		element.id = id;
	}

	// If it's an input, set type to image.
	if (type === "input") {
		element.type = "image";
		element.src = src;
	}

	// Set the class name
	if (className) {
		element.className = className;
	}

	// Set the title
	if (title) {
		element.title = title;

		if (element.className.length > 0) {
			element.className = element.className + " ";
		}

		element.className = element.className + "tooltip";
	}

	// Set the onclick function
	if (clickFunction) {
		element.onclick = clickFunction;
	}

	// Set the data attribute
	if (typeof (dataAttribute) !== 'undefined' && typeof (dataAttributeValue) !== 'undefined' && dataAttribute.length > 0 && dataAttributeValue.length > 0) {
		element.setAttribute(dataAttribute, dataAttributeValue);
	}

	return element;
}

/*
 * Adds placeholder text to a text box.
 * Added due to not all browsers supporting the placeholder attribute.
 * @param {string} input - The element name.
 * @param {string} placeholderText - The text to used as the placeholder.
 */
function addPlaceholderToTextbox(input, placeholderText) {

	// Set the value of the placeholder text.
	$("#" + input).val(placeholderText);

	// On focus.
	$("#" + input).on("focus", function (e) {
		if (this.value === placeholderText) {
			this.value = "";
		}
	});

	// On blur.
	$("#" + input).on("blur", function (e) {
		if (this.value === "") {
			this.value = placeholderText;
		}
	});
}

/**
 * Helper function to change canvas event bindings.
 * @param {string} element - The element we are updating the event for.
 * @param {string} eventType - The event type we are updating.
 * @param {function} functionToBind - The function we are binding to the event.
 */
function changeCanvasFunction(element, eventType, functionToBind) {
	if (element === undefined && eventType === undefined && functionToBind === undefined) {
		clearCanvasBindings();
	}
	else if (eventType === undefined && functionToBind === undefined) {
		clearElementBindings(element);
	}
	else {
		bindFunctionToElement(element, eventType, functionToBind);
	}
}

/**
 * Removes most binding from a given element
 * @param {object} element The element to unbind events for
 */
function clearElementBindings(element) {
	$(element).off("click");
	$(element).off("pointerdown");
	$(element).off("pointerup");
	$(element).off("pointermove.annotationUI");
}

/**
 * Binds a function to an event for a given element
 * @param {object} element The element to bind for
 * @param {string} eventType The type of event
 * @param {function} functionToBind The function to bind
 */
function bindFunctionToElement(element, eventType, functionToBind) {
	$(element).off(eventType);
	if (functionToBind !== undefined) {
		$(element).on(eventType, functionToBind);
	}
}

/**
 * Reset most bindings to their defaults
 */
function clearCanvasBindings() {
	// Clear current bindings
	$(".annotationViewer").off("click");
	$(".annotationViewer").off("pointerdown");
	$(".annotationViewer").off("pointerup");
	$(".annotationViewer").off("pointermove.annotationUI");

	if (g_oViewer.g_oArtworkViewer.g_oDoc.documentType !== eDocumentTypes.ThreeD) {
		$(".annotationViewer").on("click", function (e) {
			// Get the annotation and artwork viewer.
			oAnnotationCanvas = g_oViewer.getCanvas(e.target.id);
			oArtworkCanvas = g_oViewer.getLinkedArtworkCanvas(e.target.id);

			// Find annotations.
			g_oAnnotations.findAnnotation(e, oArtworkCanvas, oAnnotationCanvas);
		});
		$("#AnnotationViewer").on("pointermove.annotationUI", function (e) {
			oAnnotationCanvas = g_oViewer.getCanvas(e.target.id);
			oArtworkCanvas = g_oViewer.getLinkedArtworkCanvas(e.target.id);
			AnnotationAction.prototype.mouseMove(e, oArtworkCanvas, oAnnotationCanvas);
		});
		$("#CompareAnnotationViewer").on("pointermove.annotationUI", function (e) {
			oAnnotationCanvas = g_oViewer.getCanvas(e.target.id);
			oArtworkCanvas = g_oViewer.getLinkedArtworkCanvas(e.target.id);
			AnnotationAction.prototype.mouseMoveLite(e, oArtworkCanvas, oAnnotationCanvas);
		});
		$("#AnnotationViewer").on("pointerdown", function (e) {
			// Get the annotation and artwork viewer.
			oAnnotationCanvas = g_oViewer.getCanvas(e.target.id);
			oArtworkCanvas = g_oViewer.getLinkedArtworkCanvas(e.target.id);

			// Check if any handles were clicked.
			AnnotationAction.prototype.handleClick(e, oArtworkCanvas, oAnnotationCanvas);
		});
		// If we are in text compare, add the pointer down for the compare canvas.
		if (g_oTextCompare.g_bTextCompareInProgress) {
			$("#CompareAnnotationViewer").on("pointerdown", function (e) {
				// Get the annotation and artwork viewer.
				oAnnotationCanvas = g_oViewer.getCanvas(e.target.id);
				oArtworkCanvas = g_oViewer.getLinkedArtworkCanvas(e.target.id);

				// Check if any handles were clicked.
				AnnotationAction.prototype.handleClick(e, oArtworkCanvas, oAnnotationCanvas);
			});
		}
	}
	else {
		$(".annotationViewer").on("click", function (e) {
			// Get the annotation and artwork viewer.
			oAnnotationCanvas = g_oViewer.getCanvas(e.target.id);
			oArtworkCanvas = g_oViewer.getLinkedArtworkCanvas(e.target.id);

			// Find annotations.
			g_oAnnotations.findThreeDAnnotations(e, oArtworkCanvas, oAnnotationCanvas);
		});
	}
}

/**
 * Determines if a document displays as a PDF.
 * @param {eDocumentType} documentType - The document type to check.
 * @returns {bool} - If the document displays as a PDF.
 */
function documentDisplaysAsPDF(documentType) {
	return documentType === eDocumentTypes.PDF || documentType === eDocumentTypes.Office || documentType === eDocumentTypes.AI;
}

/**
 * Determines if a document displays as an SVG.
 * @param {eDocumentType} documentType - The document type to check.
 * @returns {bool} - If the document displays as an SVG.
 */
function documentDisplaysAsSVG(documentType) {
	return documentType === eDocumentTypes.SVG || documentType === eDocumentTypes.CopyMagic;
}

/**
 * Determines if a document has separations.
 * @param {eDocumentType} documentType - The document type to check.
 * @param {int} documentPages - The number of document pages.
 * @returns {bool} - If the document has separations.
 */
function documentHasSeparations(documentType, documentPages) {
	return documentType === eDocumentTypes.PDF || documentType === eDocumentTypes.Office || documentType === eDocumentTypes.AI || (documentType === eDocumentTypes.Image && documentPages > 0);
}

/**
 * Takes a measurement and converts it to millimetres if needed
 * @param {number} num The measurement in MM or Inches
 * @returns {number} The measurement in MM
 */
var MeasurementInMM = function (num) {
	if (g_oSettings.g_oUserSettings.UseMetricUnits) {
		// Came in as a mm
		return Number(DelimitNum(num, 4));
	}
	else {
		// Came in as inch, convert to mm
		return Number(DelimitNum(num * 25.4, 4));
	}
};

/**
 * Dynamically delimit a number and remove any trailing zeroes.
 * @param {number} num Number to delimit
 * @param {number} decimalPoints Max number of decimal points
 * @returns {number} Delimited number
 */
function DelimitNum(num, decimalPoints) {
	for (var i = 0; i < decimalPoints; i++) {
		if (num.toFixed(decimalPoints) % num.toFixed(i) === 0) {
			return num.toFixed(i);
		}
	}
	return num.toFixed(decimalPoints);
}

/**
 * Retrieve the element id from a given element.
 * @param {object} element Element in question
 * @returns {string} The element's id
 */
function GetElementId(element) {
	return element.id || element[0].id;
}

/**
 * Scroll a given element to a specific point over a certain time-frame
 * @param {object} element The element to scroll
 * @param {number} target Where to scroll it to in pixels
 * @param {number} time How much time to take to scroll there in milliseconds
 */
function scrollElement(element, target, time) {
	$(element).stop().animate({
		'scrollTop': target
	}, time);
}

/**
 * Sorting method to sort elements in an ascending order
 * @param {any} a Item a
 * @param {any} b Item B
 * @returns {number} Positive if a > b, negative if b < a, 0 otherwise
 */
function AscendingOrder(a, b) {
	return a - b;
}

/**
 * Un-highlights a button.
 * @param {element} elem - The button we are removing the highlighting from.
 */
function clearHighlightSelectedButton(elem) {
	$(elem).removeClass("selectedButton");
}

/**
 * Converts the UTC date to the users local using the browser time settings.
 * @param {Object|string} utcDate - The UTC date we are converting.
 * @returns {string} - The local date time AS A STRING.
 */
function convertUTCDateToLocal(utcDate) {
	var szDateFormat = "DD/MM/YYYY HH:mm:ss";
	var oDate = moment.utc(utcDate).local();
	return oDate.format(szDateFormat);
}

/* Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
*/
function debounce(func, wait, immediate) {
	var timeout;
	return function () {
		var context = this, args = arguments;
		var later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}

/**
 * Performs a deep copy on an array.
 * @param {array} oldArray Array to deep copy.
 * @returns {array} The deep copy of the array.
 */
function deepCopyArray(oldArray) {
	return jQuery.extend(true, [], oldArray);
}

/**
 * Performs a deep copy on an object
 * @param {object} oldObject Object to deep copy.
 * @returns {object} The deep copy of the object.
 */
function deepCopyObject(oldObject) {
	return jQuery.extend(true, {}, oldObject);
}

/**
 * Displays any errors within the html.
 * @param {array} errors - The list of errors.
 * @returns {string} HTML of the errors.
 */
function displayErrorContentHTML(errors) {

	// Declare a variable to hold the error content.
	var szHTML = "";

	// If the error object is an array, add each of the errors to the list.
	if (Array.isArray(errors)) {
		if (errors.length > 0) {
			for (var i = 0; i < errors.length; i++) {
				var oErr = errors[i];
				szHTML += "<li type='square'>" + oErr.errorDescription + "</li>";
			}
		}
	}

	// Return the error content.
	return szHTML;
}

/**
 * Generates the HTML for the error bubble for a single error message..
 * @param {string} errorMessage - The error message.
 * @returns {string} HTML of the error message within a list item element.
 */
function displayErrorResultHTML(errorMessage) {
	return "<li type='square'>" + errorMessage + "</li>";
}

// Confirm bubble auto closing.
$(document).on('click', function (event) {

	// Loop through each of the active bubbles.
	for (var i = 0; i < g_oActiveBubbles.length; i++) {

		// If this bubble is a confirmation bubble.
		if (g_oActiveBubbles[i].type === "Confirm") {

			// Get the current date time.
			var dtNow = new Date();

			// If we have not clicked on this bubble, and the bubble has been active for more than the configured seconds.
			if ($(event.target).parents("#divGLSpeech" + g_oActiveBubbles[i].id).length === 0 &&
				(((dtNow - g_oActiveBubbles[i].displayDate) / 1000) > g_iBubbleCloseSeconds)) {

				// Close the confirmation bubble.
				g_oGreenlightMessages.closeBubble(g_oActiveBubbles[i].id, true, true);
				i--;
			}
		}
	}
});

/**
 * Format a date in the users preference.
 * @param {Object|string} Date - The Date to be formatted. If string should be ISO 8601.
 * @returns {string} Date Formatted
 */
function formatDate(Date) {
	
	// The position of the date format in the array.
	var iDateArrayPos = 0;
	
	// The position of the time format in the array.
	var iTimeArrayPos = 1;

	// Outline the default date elements.
	var oDateElements = ["dd/MM/yyyy", "HH:mm:ss"];

	// If we have a setting for the date format.
	if (!isNothing(g_oSettings.c_szDateFormat)) {

		// Split the users date format.
		oDateElements = g_oSettings.c_szDateFormat.split(' ');
	}

	// Convert the date to the format.
	var szDate = moment(Date).format(oDateElements[iDateArrayPos].toUpperCase() + " " + oDateElements[iTimeArrayPos]).substring();

	// Remove the seconds and return.
	return szDate.substring(0, szDate.length - 3);
};

/**
 * Generates a GUID.
 * @returns {string} - The newly generated GUID.
 */
function generateGuid() {
	function s4() {
		return Math.floor((1 + Math.random()) * 0x10000)
		.toString(16)
		.substring(1);
	}
	return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
		s4() + '-' + s4() + s4() + s4();
}

/**
 * Returns the correct height of the browser window.
 * @returns {int} Correct height of browser window.
 */
function getClientHeight() {
	var iClientHeight = $(window).height();
	return iClientHeight;
}

/**
 * Returns the correct width of the browser window.
 * @returns {int} Correct width of the browser window.
 */
function getClientWidth() {
	var iClientWidth = $(window).width();
	return iClientWidth;
}

/**
 * Returns the correct vertical scrolling amount of the browser window.
 * @returns {int} Correct vertical scrolling amount.
 */
function getScrollAmountY() {
	var iScrollAmountY = $(window).scrollTop();
	return iScrollAmountY;
}

/**
 * Highlights a button, clearing highlights off all but the navigation section.
 * @param {element} elem - The button we are highlighting.
 * @param {Boolean} removeCurrentHighlight - Remove the current highlight.
 */
function highlightSelectedButton(elem, removeCurrentHighlight) {
	if (removeCurrentHighlight) {
		removeExistingHighlights("#tblNavTools .selectedButton");
	}
	$(elem).addClass("selectedButton");
}

/**
 * Highlights the passed in element, whilst removing all existing highlights.
 * @param {element} elem - The button we are highlighting.
 * @param {Boolean} removeCurrentHighlight - Remove the current highlight.
 */
function highlightButtonClearingAllIcons(elem, removeCurrentHighlight) {
	if (removeCurrentHighlight) {
		removeExistingHighlights(null);
	}
	$(elem).addClass("selectedButton");
}

/**
 * Function to determine if a string is nothing or not.
 * @param {string} string String to check.
 * @returns {bool} True if the string is not nothing else false.
 */
function isNothing(string) {
	if (string !== null && string + "" !== "") { return false; }
	else { return true; }
}

/**
 * Function to check that a string contains only numeric characters.
 * @param {string} string String to validate.
 * @param {bool} required Is the validation required.
 * @returns {bool} True if the string only contains numeric characters.
 */
function isNumeric(string, required) {
	if (isNothing(string) && required) { return false; }
	else if (isNothing(string)) { return true; }
	else {
		var szTxt = string;
		var iLen = szTxt.length;
		for (var i = 0; i !== iLen; i++) {
			var aChar = szTxt.substring(i, i + 1);
			if (aChar < "0" || aChar > "9") { return false; }
		}
	}

	return true;
}

/**
 * Removes the existing button highlights.
 * @param {Element} notSelector notSelector element.
 */
function removeExistingHighlights(notSelector) {

	// Remove existing selected buttons that do not fall in the nor selector.
	$(".selectedButton").not($(notSelector)).removeClass("selectedButton");

	// If we are finding SVG text, this must remain highlighted.
	if (g_oViewer.c_bFindSVGText) {
		$("#btnSVGFindText").addClass("selectedButton");
	}

	// Toggle the drop down content.
	$(".dropdown-content:visible").slideToggle(200);
}

/**
 * Resizes the viewer cell to fit the screen.
 */
function resizeViewerCell() {

	// Start with the width and height of the window.
	var iWidth = $(window).width();
	var iHeight = $(window).height();

	// Remove 16px for the width margin from the width.
	iWidth -= 16;

	// Remove the height of the toolbar container from the height.
	iHeight -= $("#divContainer").height();

	// Set the width and height of the viewer cell.
	$("#divViewerCell").css("width", iWidth);
	$("#divViewerCell").css("height", iHeight);
}

/**
 *	Calculate the width of the slide out div container.
 *	@returns {number} the width in pixels
 */
function calculateSlideOutDivSize() {
	var iCanvasWidth = $("#divViewerCell").width();
	return iCanvasWidth / 5;
}

/**
 * Slides a div out.
 * @param {object} elem - The element we are sliding.
 * @param {bool} leftMenu - If the div should be animated from the left or right side.
 * @param {bool} toggle - If the div is being toggled.
 */
function slideDiv(elem, leftMenu, toggle) {

	// Get the width and height of the canvas.
	var iCanvasWidth = $("#divViewerCell").width();
	var iCanvasHeight = $("#divViewerCell").height();

	var divWidth = calculateSlideOutDivSize();

	// Set the width of the element to be relative of the canvas size.
	$(elem).width(divWidth - 8); // 8px Margin.
	$("#" + $(elem).children()[0].id).width(divWidth - 8); // 8px Margin.

	// Set the height of the element to be relative of the canvas size.
	$(elem).height(iCanvasHeight);
	$("#" + $(elem).children()[0].id).height(iCanvasHeight);

	// Show the element if we are not in alignment mode.
	if (!g_oCompare.g_bAlignmentModeActive && !g_oTextCompare.g_bTextCompareInProgress) {
		$(elem).toggle(true);
	}

	// Declare the required variables.
	var iLeftPos = parseInt($(elem).css('left'));
	var iTargetLeftPos = 0;
	var bSlideOut = false;
	var bRotate = false;

	// If we are sliding in from the left.
	if (leftMenu) {

		// Slide Out.
		if ((toggle && iLeftPos <= 0) || (!toggle && !g_oSettings.g_oUserSettings.LeftMenuCollapse)) {
			iTargetLeftPos = 8; // 8px Margin.
			bSlideOut = true;
			bRotate = true;
		}
		// Slide In.
		else {
			iTargetLeftPos = (-($(elem).width())) + 8; // 8px Margin.
			bSlideOut = false;
			bRotate = false;
		}

		// Update the user preferences.
		g_oSettings.g_oUserSettings.LeftMenuCollapse = !bSlideOut;
	}
	// If we are sliding in from the right.
	else {

		// Slide Out.
		if ((toggle && (iLeftPos >= iCanvasWidth || iLeftPos === 0)) || (!toggle && !g_oSettings.g_oUserSettings.RightMenuCollapse)) {
			iTargetLeftPos = iCanvasWidth - $(elem).width() + 8; // 8px Margin.
			bSlideOut = true;
			bRotate = false;
		}
		// Slide In.
		else {
			iTargetLeftPos = iCanvasWidth + 8; // 8px Margin.
			bSlideOut = false;
			bRotate = true;
		}

		// Update the user preferences.
		g_oSettings.g_oUserSettings.RightMenuCollapse = !bSlideOut;
	}

	// Determine animation to move in from the left
	var iAnimateLeft = (parseInt($(elem).css('left')) === iTargetLeftPos) ? iLeftPos : iTargetLeftPos;

	// If we are sliding out, make sure the child div is shown.
	if (bSlideOut) {
		$($(elem).children()[0]).show();
	}

	// Animate the div, then hide the child div if not sliding out.
	$(elem).animate(
		{left: iAnimateLeft + 'px'}, // Animate the div to the correct position.
		(toggle ? 400 : 0), // Animate slowly if we are toggling.
		function () {

			// Hide the child div after animation if sliding in.
			if (!bSlideOut) {
				$($(elem).children()[0]).hide();
			}

			// If this is the right menu.
			if (bSlideOut && !leftMenu) {

				// Resize the separations and checklist items.
				resizeSeparationListItems();
				reziseChecklistItems();
			}
			// If this is the left menu.
			else if (bSlideOut && leftMenu) {

				// Resize the annotations list items.
				resizeAnnotationListItems();
			}

			// If sliding out and we have active annotation bubbles, redraw any annotations to adjust for the slide out.
			if (bSlideOut && !$.isEmptyObject(g_oAnnotations) && $(".speechbubble").length > 0) {
				g_oViewer.getCanvas(g_oCompare.getAnnotationCanvasId()).redraw(false);
			}
		}
	);

	// Update the transform of the arrow icon.
	$("#" + (leftMenu ? "divAnnButtonArrow" : "divSepButtonArrow")).css("transform", (bRotate ? "rotate(180deg)" : ""));
}

/**
 * Resizes the height of the separations list items div.
 */
function resizeAnnotationListItems() {
	
	// Set the height of the annotations list div to the full viewer cell.
	var iAnnotationsListHeight = $("#divViewerCell").height();

	// Remove the height of the header div.
	if ($("#divAnnDiv_Header").length > 0) {
		iAnnotationsListHeight -= $("#divAnnDiv_Header")[0].offsetHeight;
	}

	// Remove the height of the filters div.
	if ($("#divAnnFilters").length > 0) {
		iAnnotationsListHeight -= $("#divAnnFilters")[0].offsetHeight;
	}

	// Update the height of the annotations list div.
	if ($("#divAnnDiv_ListItems").length > 0) {
		$("#divAnnDiv_ListItems").css("height", iAnnotationsListHeight);
	}
}

/**
 * Resizes the height of the separations list items div.
 */
function resizeSeparationListItems() {

	// Set the height of the separations list div to the full viewer cell.
	var iSeparationsListHeight = $("#divViewerCell").height();

	// Remove the height of the navigator div.
	if ($("#divNavigator").length > 0) {
		iSeparationsListHeight -= $("#divNavigator")[0].offsetHeight;
	}

	// Remove the height of the disabled navigator div.
	if ($("#divNavigatorDisabled").length > 0) {
		iSeparationsListHeight -= $("#divNavigatorDisabled")[0].offsetHeight;
	}

	// Remove the height of the checklist tabs.
	if ($("#divChecklistTabs").length > 0) {
		iSeparationsListHeight -= $("#divChecklistTabs")[0].offsetHeight;
	}

	// Remove the height of the separations list header div.
	if ($("#divSeparationItems_Header").length > 0) {
		iSeparationsListHeight -= $("#divSeparationItems_Header")[0].offsetHeight;
	}

	// Update the height of the separations list div.
	if ($("#divSeparationItems").length > 0) {
		$("#divSeparationItems").css("height", iSeparationsListHeight);
	}
}

/**
 * Resizes the checklist tab.
 */
function reziseChecklistItems() {

	// Set the height of the checklist list div to the full viewer cell.
	var iChecklistListHeight = $("#divViewerCell").height();

	// Remove the height of the navigator div.
	if ($("#divNavigator").length > 0) {
		iChecklistListHeight -= $("#divNavigator")[0].offsetHeight;
	}

	// Remove the height of the disabled navigator div.
	if ($("#divNavigatorDisabled").length > 0) {
		iChecklistListHeight -= $("#divNavigatorDisabled")[0].offsetHeight;
	}

	// Remove the height of the checklist tabs.
	if ($("#divChecklistTabs").length > 0) {
		iChecklistListHeight -= $("#divChecklistTabs")[0].offsetHeight;
	}

	// Update the height of the separations list div.
	if ($("#divChecklist").length > 0) {
		$("#divChecklist").css("height", iChecklistListHeight);
	}
}

/**
 * Swaps an image objects source.
 * @param {string} imgElement HTML id of the img element to change the src of.
 * @param {string} newImageSrc The source of the image to swap to.
 */
function swapImage(imgElement, newImageSrc) {
	if ($("#" + imgElement).exists()) {
		$("#" + imgElement).attr("src", newImageSrc);
	}
}

/**
 * Locks the screen.
 */
function lockScreen() {
	$("#divLockScreen").fadeIn(600);
}

/**
 * Unlocks the screen.
 */
function unlockScreen() {
	$("#divLockScreen").fadeOut(600);
}

/**
 * Shows the spinner message.
 * @param {string} message - The message to be shown.
 */
function showSpinnerMessage(message) {
	$("#divSpinnerMessage").html(message);
	$("#divSpinnerMessage").fadeIn(600);
}

/** 
 * Hides the spinner message. 
 */
function hideSpinnerMessage() {
	$("#divSpinnerMessage").html("");
	$("#divSpinnerMessage").fadeOut(600);
}

/**
 * Shows the pop-up and locks the window behind.
 * @param {string} div HTML id of the div to display as the pop up window.
 * @param {int} percentX Percentage of the screens width this pop-up will take.
 * @param {int} percentY Percentage of the screens height this pop-up will take.
 */
function displayPopupWindow(div, percentX, percentY) {

	// Check the div exists.
	if ($("#" + div).exists()) {

		// Lock window firstly
		lockScreen();
		// Hide spinner
		$('#imgSpinner').hide();
		// Calculate the Pop-up position and content sizes.
		calculateContentPositions(div, percentX, percentY, false);

		// Show the window.
		$("#" + div).fadeIn();
	}
}

function flatten(array) {
	return [].concat.apply([], array);
}

/**
* Hides the pop-up and unlocks the window.
* @param {string} div HTML id of the div to hide.
*/
function hidePopupWindow(div) {

	// Check the div exists.
	if ($("#" + div).exists()) {

		// Hide the pop-up.
		$("#" + div).fadeOut();

		// Unlock the window.
		unlockScreen();

		// show the spinner
		$('#imgSpinner').show();
	}
}

/**
 * Returns the correct horizontal scrolling amount of the browser window.
 * @returns {int} Correct horizontal scrolling amount.
 */
function getScrollAmountX() {
	var iScrollAmountX = $(window).scrollLeft();
	return iScrollAmountX;
}

/**
 * Called when a file is dragged over the file upload control.
 * @param {event} e - event object
 */
function dragOverFile(e) {

	// Stop the browsers default behaviour.
	e.preventDefault();
	e.stopPropagation();

	// Add the drag over outline active class to the file upload control.
	$("#divFileUpload").addClass("uploadZoneActive");
}

/**
 * Called when a file is dragged out of the file upload control.
 * @param {event} e - event object
 */
function dragLeaveFile(e) {

	// Stop the browsers default behaviour.
	e.preventDefault();
	e.stopPropagation();

	// Remove the drag over outline active class from the file upload control.
	$("#divFileUpload").removeClass("uploadZoneActive");
}

/**
 * Called when a file is dropped over the upload control.
 * @param {event} e - event object.
 */
function droppedFile(e) {

	// Set that we are uploading files.
	g_oAnnotationAttachments.setUploadingStatus(true);

	// Stop the browsers default behaviour.
	e.preventDefault();
	e.stopPropagation();

	// Remove the drag over outline active class from the file upload control.
	$("#divFileUpload").removeClass("uploadZoneActive");

	// Add the dropped attachments.
	var dt = e.dataTransfer;
	g_oAnnotationAttachments.addAnnotationAttachments(dt.files);
}

/**
 * Calculate the div position and content sizes (pop-up percentage size specified).
 * @param {string} div HTML id of the div to calculate the positions and content sizes for.
 * @param {int} x Percentage of the screens width this pop-up will take.
 * @param {int} y Percentage of the screens height this pop-up will take.
 * @param {bool} switched If false the z-index will be updated.
 */
function calculateContentPositions(div, x, y, switched) {
	// Calculate the Pop-up positions.
	var idivHeight = y * getClientHeight() / 100;
	var idivWidth = x * getClientWidth() / 100;
	var iTop = calculateCentralYCoordinate(parseInt(idivHeight, 10));
	var iLeft = calculateCentralXCoordinate(parseInt(idivWidth, 10));

	// Round the Pop-up positions to the nearest whole number.
	idivHeight = Math.round(idivHeight);
	idivWidth = Math.round(idivWidth);
	iTop = Math.round(iTop);
	iLeft = Math.round(iLeft);

	// Get the margin size for the header to subtract from the height.
	var iHeaderMargin = 0;

	//// If we have a skin folder, check if this needs to be amended for the classic view.
	//if (typeof (g_oUserProfile) != "undefined" && g_oUserProfile.skinFolder == "cls") {
	//    iHeaderMargin = 20;
	//}

	// Apply the CSS.
	var oPopup = $("#" + div);
	oPopup.css({
		"height": idivHeight,
		"width": idivWidth,
		"top": iTop,
		"left": iLeft
	});

	//if (!switched) {
	//    oPopup.css("z-index", 1000 + (10 * g_iCurrLockingLevel));
	//}

	// Calculate the Pop-up content height and widths (required for scrolling).
	var oPopupContent = $("#" + div + "_Content");
	if (oPopupContent.exists()) {

		var iHeaderHeight = $("#" + div + "_Header").height();

		oPopupContent.css({
			"height": (idivHeight - iHeaderHeight - iHeaderMargin),	// 20px (cls) or 30px (mod) margin space.
			"width": (idivWidth - 15)								// 15px margin space.
		});

		if (oPopup.has("#divPopUpContent_Content") && $("#" + div).has("#divPopUpContent_Header")) {
			var mainHeight = oPopupContent.height();
			var header = oPopupContent.find("#divPopUpContent_Header").height();
			oPopupContent.find("#divPopUpContent_Content").css("height", mainHeight - header - iHeaderMargin);
		}
	}
}

function elementExistsAndIsVisible(element) {
	return $(element).exists() && $(element).is(":visible");
}

/**
 * Calculates the correct Y position to place an object in the centre of the window.
 * @param {int} objectHeight Height of the object to center.
 * @returns {int} Y position.
 */
function calculateCentralYCoordinate(objectHeight) {
	var iHeight = getClientHeight();
	var iTop = getScrollAmountY() + (iHeight - objectHeight) / 2;
	return iTop;
}

/**
 * Calculates the correct X position to place an object in the centre of the window.
 * @param {int} objectWidth Width of object to center.
 * @returns {int} X position.
 */
function calculateCentralXCoordinate(objectWidth) {
	var iWidth = getClientWidth();
	var iLeft = getScrollAmountX() + (iWidth - objectWidth) / 2;
	return iLeft;
}

/*
 * Takes a value and rounds it to the specified number.
 * Code taken from this StackOverflow post:
 * https://stackoverflow.com/questions/1726630/formatting-a-number-with-exactly-two-decimals-in-javascript
 */
function round(value, exp) {
	if (typeof exp === 'undefined' || +exp === 0) {
		return Math.round(value);
	}

	value = +value;
	exp = +exp;

	if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
		return NaN;
	}

	// Shift
	value = value.toString().split('e');
	value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp)));

	// Shift back
	value = value.toString().split('e');
	return +(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp));
}

/**
 * Adds two floats safely.
 * Due to the way js floats are combined, the 1000 is required to ensure exact accuracy adding.
 * @param {float} x - The first float value.
 * @param {float} y - The second float value.
 * @returns {float} - The sum of the floats.
 */
function addFloats(x, y) {
	return ((x * 1000) + (y * 1000)) / 1000;
}

/**
 * Sebtracts two floats safely.
 * Due to the way js floats are combined, the 1000 is required to ensure exact accuracy subtracting.
 * @param {float} x - The first float value.
 * @param {float} y - The second float value.
 * @returns {float} - The return of the float subtraction.
 */
function subtractFloats(x, y) {
	return ((x * 1000) - (y * 1000)) / 1000;
}

/*
 * Parses a value to check that it is an integer.
 * Code taken from this StackOverflow post:
 * https://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript
 */
function isInt(value) {
	if (isNaN(value)) {
		return false;
	}

	var x;
	x = parseFloat(value);
	return (x | 0) === x;
}


function contains(R1_x, R1_y, R1_w, R1_h, R2_x, R2_y, R2_w, R2_h) {
	if ((R2_x + R2_w) <= (R1_x + R1_w) &&
		(R2_x) >= (R1_x) &&
		(R2_y) >= (R1_y) &&
		(R2_y + R2_h) <= (R1_y + R1_h)
	) {
		return true;
	}
	else {
		return false;
	}
}

/**
 * Gets the clicked coordinates.
 * @param {object} event - The click event.
 * @param {object} oViewer - The viewer containing the canvas the user has clicked on.
 * @returns {number[]} - X & Y coordinates.
 */
function getClickCoords(event, oViewer) {
	var x = event.x || event.clientX + document.body.scrollLeft + document.getElementById(oViewer.g_szCanvasId).scrollLeft + document.documentElement.scrollLeft;
	var y = event.y || event.clientY + document.body.scrollTop + document.getElementById(oViewer.g_szCanvasId).scrollTop + document.documentElement.scrollTop;
	var rect = oViewer.g_oCanvas.getBoundingClientRect();

	x = x - rect.left;
	y = y - rect.top;

	// Factor in the users DPI for the click co-ordinates.
	x *= g_oViewer.c_iDPI;
	y *= g_oViewer.c_iDPI;

	return [x, y];
}

/**
 * Gets the number of frames to be used for the zoom animation.
 * @param {eZoomSpeed} zoomSpeed - The speed of the zoom.
 * @returns - Int number of frames.
 */
function getAnimationFramesForZoomSpeed(zoomSpeed) {
	switch (zoomSpeed) {
		case eZoomSpeed.Slow: return 15;
		case eZoomSpeed.Medium: return 10;
		case eZoomSpeed.Fast: return 5;
		default: return 5;
	}
}

/**
 * Gets the multiplier for the zoom increment.
 * @param {eZoomIncrements} zoomIncrement - The zoom increment.
 * @returns - Float zoom multiplier.
 */
function getZoomMultiplierForZoomIncrement(zoomIncrement) {
	switch (zoomIncrement) {
		case eZoomIncrements.Smallest: return 1.2;
		case eZoomIncrements.Small: return 1.5;
		case eZoomIncrements.Medium: return 2;
		case eZoomIncrements.Large: return 3;
		case eZoomIncrements.Largest: return 4;
		default: return 2;
	}
}

/**
 * Fakes getClickCoords as if it were made on the given coordinates
 * @param {any} x The x coordinate
 * @param {any} y The y coordinate
 * @param {any} oViewer The viewer containing the canvas the user has clicked on.
 * @returns {number[]} A set of coordinates
 */
function fakeClickCoords(x, y, oViewer) {
	var rect = oViewer.g_oCanvas.getBoundingClientRect();

	x = x - rect.left;
	y = y - rect.top;

	// Factor in the users DPI for the click co-ordinates.
	x *= g_oViewer.c_iDPI;
	y *= g_oViewer.c_iDPI;

	return [x, y];
}

/**
 * Transforms the event click coordinates into coordinates on the canvas
 * @param {event} event - The event reference.
 * @param {object} oArtworkCanvas - The artwork canvas.
 * @param {object} oAnnotationsUI - The annotationsUI reference.
 * @returns {number} co-ordinates
 */
function findClickCanvasCoordinates(event, oArtworkCanvas, oAnnotationsUI) {
	var oCoords = oAnnotationsUI.getClick(event, oArtworkCanvas);
	var iCompareOffset = g_oCompare.calculateCompareOffsetInPx(oArtworkCanvas);
	switch (oArtworkCanvas.g_iRotDegrees) {
		case 90:
		case 270:
			return [(oCoords[0] - iCompareOffset.x) / oArtworkCanvas.g_iScaledImageHeight, (oCoords[1] - iCompareOffset.y) / oArtworkCanvas.g_iScaledImageWidth];
		case 180:
		default:
			return [(oCoords[0] - iCompareOffset.x) / oArtworkCanvas.g_iScaledImageWidth, (oCoords[1] - iCompareOffset.y) / oArtworkCanvas.g_iScaledImageHeight];
	}
}

/*
 *  - - - O B J E C T   P R O T O T Y P E S - - -
 */

function Seperation() {
	this.SeperationName = "";
	this.Red = 0;
	this.Green = 0;
	this.Blue = 0;
	this.Opaque = "";
	this.OriginalRed = 0;
	this.OriginalGreen = 0;
	this.OriginalBlue = 0;
	this.OriginalOpaque = "";
	this.ImageWidth = 0;
	this.ImageHeight = 0;
	this.Visable = true;
	this.WidthResolution = 0;
	this.HeightResolution = 0;
}

function ImageDimensions() {
	this.MinX = 0;
	this.MinY = 0;
	this.MaxX = 0;
	this.MaxY = 0;
}

function ImageObject() {
	this.Width = 0;
	this.Height = 0;
}

function ImageBox() {
	this.RequestApproval = 0;
	this.RequestedPage = 0;
	this.RequestedImageObject = new ImageObject();
	this.ImagePercentages = new ImageDimensions();
	this.UserImageObject = new ImageObject();
	this.CompareImageObject = new ImageObject();
	this.ScaledImageObject = new ImageObject();
	this.CompareOffsetX = 0;
	this.CompareOffsetY = 0;
	this.CompareRotationDegrees = 0;
	this.VisibleSeparations = new Array();					// An array of Separation Objects.
}

/**
 * Imaging Engine Request Object.
 */
function ImageRequest() {
	this.SessionId;
	this.OriginalResolution;				// Translates to a nullable int in the C# code so no default is being set.
	this.ApprovalId = 0;
	this.CompareMode = eCompareMode.NoCompare;
	this.ImageRequestName = "";
	this.ArtworkViewerImageBox = new ImageBox();
	this.CompareViewerImageBox = new ImageBox();
	this.IsCompareImageRequest = false;
	this.CompareGhosting = 0;
	this.CompareTolerance = 0;
	this.IsGetNewImageCallType = false;
	this.OverrideSingleColourChange = false;
}

/**
 * Examine Image Request Object.
 * Used for the Colour Density, Barcode & Text Measurement Technical Tools.
 */
function ExamineImageRequest() {
	this.DocumentName = "";
	this.Dimensions = new ImageDimensions();
	this.ApprovalID = 0;
	this.PageNumber = 0;
	this.ExamTypeCode = g_oTechTools.g_eExamTypes.COLOURDENSITY;
	this.CurrentResolution = 0;
	this.OriginalResolution = 0;
	this.RealtimeRenderReference = "";
	this.AnnotationID = -1;
	this.FullImageHeight = 0;
	this.FullImageWidth = 0;
}

/**
 * Barcode Measurement Object.
 * Used to hold the details of the separation barcode measurement details.
 */
function BarcodeMeasurement() {
	this.SeparationName = "";
	this.CodeType = "";
	this.CodeData = "";
	this.DisplayText = "";
	this.MarqueeCoordinates = new ImageDimensions();
	this.widthMagnification = "";
	this.X = 0;
	this.Y = 0;
	this.Width = 0;
	this.Height = 0;
}

/**
 * Used to get a filename without its extension
 * @param {string} FileName - Name of file.
 * @returns {string} Name of file.
 */
function GetFileNameWithoutExtension(FileName) {
	return FileName.substring(0, FileName.lastIndexOf('.'));
}

// Polyfill for IE. Useless.
Math.log2 = Math.log2 || function (x) {
	return Math.log(x) * Math.LOG2E;
};

/**
 * Add Polyfill for .contains for IE. Useless.
 * @returns {bool} If this contains anything within arguments.
 */
if (!String.prototype.contains) {
	String.prototype.contains = function () {
		return String.prototype.indexOf.apply(this, arguments) !== -1;
	};
}

/**
 * Polyfill for .prepend
 * Source: https://developer.mozilla.org/en-US/docs/Web/API/ParentNode/prepend
 */
(function (arr) {
	arr.forEach(function (item) {
		if (item.hasOwnProperty('prepend')) {
			return;
		}
		Object.defineProperty(item, 'prepend', {
			configurable: true,
			enumerable: true,
			writable: true,
			value: function prepend() {
				var argArr = Array.prototype.slice.call(arguments),
					docFrag = document.createDocumentFragment();

				argArr.forEach(function (argItem) {
					var isNode = argItem instanceof Node;
					docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
				});

				this.insertBefore(docFrag, this.firstChild);
			}
		});
	});
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);

/**
 * Process API Response for errors.
 * @param {object} xhr - Response from the API.
 * @param {string} textStatus - Response from the API.
 * @param {boolean} bNoFormatting - Whether to skip formatting message into HTML.
 */
function ProcessApiError(xhr, textStatus, bNoFormatting) {
    var szMessage = textStatus;
    switch (xhr.status) {
        case 400: // Bad Request
            szMessage = xhr.responseJSON.Message;
            break;
        case 401: // Unauthorised
            szMessage = g_oGreenlightMessages.c_szUnauthorisedMessage;
            break;
        case 500: // Server Error
            szMessage = xhr.responseText;
            break;
	}

	if (!bNoFormatting) {
		szMessage = displayErrorResultHTML(szMessage);
	}

	g_oGreenlightMessages.displayErrorBubble(szMessage);
}


//http://blog.acipo.com/matrix-inversion-in-javascript/
function matrix_invert(M) {
	// I use Gaussian Elimination to calculate the inverse:
	// (1) 'augment' the matrix (left) by the identity (on the right)
	// (2) Turn the matrix on the left into the identity by elementary row ops
	// (3) The matrix on the right is the inverse (was the identity matrix)
	// There are 3 elementary row ops: (I combine b and c in my code)
	// (a) Swap 2 rows
	// (b) Multiply a row by a scalar
	// (c) Add 2 rows

	//if the matrix isn't square: exit (error)
	if (M.length !== M[0].length) { return; }

	//create the identity matrix (I), and a copy (C) of the original
	var i = 0, ii = 0, j = 0, dim = M.length, e = 0, t = 0;
	var I = [], C = [];
	for (i = 0; i < dim; i += 1) {
		// Create the row
		I[I.length] = [];
		C[C.length] = [];
		for (j = 0; j < dim; j += 1) {

			//if we're on the diagonal, put a 1 (for identity)
			if (i == j) { I[i][j] = 1; }
			else { I[i][j] = 0; }

			// Also, make the copy of the original
			C[i][j] = M[i][j];
		}
	}

	// Perform elementary row operations
	for (i = 0; i < dim; i += 1) {
		// get the element e on the diagonal
		e = C[i][i];

		// if we have a 0 on the diagonal (we'll need to swap with a lower row)
		if (e == 0) {
			//look through every row below the i'th row
			for (ii = i + 1; ii < dim; ii += 1) {
				//if the ii'th row has a non-0 in the i'th col
				if (C[ii][i] != 0) {
					//it would make the diagonal have a non-0 so swap it
					for (j = 0; j < dim; j++) {
						e = C[i][j];       //temp store i'th row
						C[i][j] = C[ii][j];//replace i'th row by ii'th
						C[ii][j] = e;      //replace ii'th by temp
						e = I[i][j];       //temp store i'th row
						I[i][j] = I[ii][j];//replace i'th row by ii'th
						I[ii][j] = e;      //replace ii'th by temp
					}
					//don't bother checking other rows since we've swapped
					break;
				}
			}
			//get the new diagonal
			e = C[i][i];
			// if it's still 0, not invertible (error)
			if (e == 0) { return; }
		}

		// Scale this row down by e (so we have a 1 on the diagonal)
		for (j = 0; j < dim; j++) {
			C[i][j] = C[i][j] / e; //apply to original matrix
			I[i][j] = I[i][j] / e; //apply to identity
		}

		// Subtract this row (scaled appropriately for each row) from ALL of
		// the other rows so that there will be 0's in this column in the
		// rows above and below this one
		for (ii = 0; ii < dim; ii++) {
			// Only apply to other rows (we want a 1 on the diagonal)
			if (ii == i) { continue; }

			// We want to change this element to 0
			e = C[ii][i];

			// Subtract (the row above(or below) scaled by e) from (the
			// current row) but start at the i'th column and assume all the
			// stuff left of diagonal is 0 (which it should be if we made this
			// algorithm correctly)
			for (j = 0; j < dim; j++) {
				C[ii][j] -= e * C[i][j]; //apply to original matrix
				I[ii][j] -= e * I[i][j]; //apply to identity
			}
		}
	}

	//we've done all operations, C should be the identity
	//matrix I should be the inverse:
	return I;
}

/*
 *  - - - C O L O U R   F U N C T I O N S - - -
 */

// Converts a hex colour to rgb.
function convertColourHexToRGB(szHex) {
	var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(szHex);
	return result ? {
		r: parseInt(result[1], 16),
		g: parseInt(result[2], 16),
		b: parseInt(result[3], 16)
	} : {
		r: 0,
		g: 0,
		b: 0
	};
}

// Converts an rbg string to rbg.
function convertColourToRBG(szRGB) {
	var result = szRGB.replace(/[^\d,]/g, '').split(',');
	return result ? {
		r: parseInt(result[0]),
		g: parseInt(result[1]),
		b: parseInt(result[2])
	} : {
		r: 0,
		g: 0,
		b: 0
	};
}

// Converts an rgb string to srgb.
function convertRGBToSRGB(oRGB) {
	return {
		r: oRGB.r / 255,
		g: oRGB.g / 255,
		b: oRGB.b / 255
	}
}

// Converts RGB to hex.
function convertRGBToHex(r, g, b) {

	// Convert any values to an int and check the bounds.
	r = Math.max(0, Math.min(255, parseInt(r)));
	g = Math.max(0, Math.min(255, parseInt(g)));
	b = Math.max(0, Math.min(255, parseInt(b)));

	// Return the hex value.
	return "#" + convertRGBComponentToHex(r) + convertRGBComponentToHex(g) + convertRGBComponentToHex(b);
}

// Converts an RBG component to hex.
function convertRGBComponentToHex(c) {
	var hex = c.toString(16);
	return hex.length == 1 ? "0" + hex : hex;
}

// Calculates the luminance of an srgb colour.
function calculateLuminance(oSRGB) {

	// Calculate the luminance of each colour.
	var oLuminacne = {
		r: (oSRGB.r <= 0.03928) ? (oSRGB.r / 12.92) : Math.pow(((oSRGB.r + 0.055) / 1.055), 2.4),
		g: (oSRGB.g <= 0.03928) ? (oSRGB.g / 12.92) : Math.pow(((oSRGB.g + 0.055) / 1.055), 2.4),
		b: (oSRGB.b <= 0.03928) ? (oSRGB.b / 12.92) : Math.pow(((oSRGB.b + 0.055) / 1.055), 2.4)
	}

	// Return the luminance total.
	return (0.2126 * oLuminacne.r) + (0.7152 * oLuminacne.g) + (0.0722 * oLuminacne.b);
}

/** 
 *  Check if we are using IE.
 *  @returns {bool} - True or False.
 */
function isIE() {
	var ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
	var msie = ua.indexOf('MSIE '); // IE 10 or older
	var trident = ua.indexOf('Trident/'); //IE 11

	return (msie > 0 || trident > 0);
}